import AjaxPromises from '../utils/AjaxPromises';

import { endPoints as EndPoints } from '../constants/UserConstants';

export default {

    getRegisterList: (formData) => {
        return AjaxPromises.POST(EndPoints.GET_LIST_OF_REGISTERS, formData);
    },

    loadRooms: (formData) => {
        return AjaxPromises.POST(EndPoints.GET_LIST_OF_ROOMS, formData);
    },

    getLocationSettings: (formData) => {
        return AjaxPromises.POST(EndPoints.GET_LOCATION_SETTINGS, formData);
    },

    getUserDetails: (formData) => {
        return AjaxPromises.POST(EndPoints.GET_USER_DETAILS, formData);
    },

    checkDPHCredentials: (formData) => {
        return AjaxPromises.POST(EndPoints.VALIDATE_DPH_CREDENTIALS, formData);
    },

    loadCustomerTypes: (formData) => {
        return AjaxPromises.POST(EndPoints.GET_CUSTOMER_TYPES, formData);
    },

    getValidatedForms: (formData) => {
        return AjaxPromises.POST(EndPoints.GET_VALIDATED_FROMS, formData);
    },

    getEnvironmentDetails: (formData) => {
        return AjaxPromises.GET(EndPoints.GET_ENVIRONMENT_DETAILS, formData);
    },

    consumeLoginToken: (formData) => {
        return AjaxPromises.POST(EndPoints.CONSUME_LOGIN_TOKEN, formData);
    },
    generateLoginToken: (formData) => {
        return AjaxPromises.POST(EndPoints.GENERATE_LOGIN_TOKEN, formData);
    },
    getLaunchDarklyFlags: (formData) => {
        return AjaxPromises.POST(EndPoints.GET_LD_FLAGS, formData);
    },
};



// WEBPACK FOOTER //
// ./ui_src/app/api/UserApi.jsx